import { ButtonDisplay } from 'components/Buttons/ButtonDisplay';
import 'twin.macro';

interface Props {
  fields: { label: string; value: string }[];
  values: string[];
  onChange: (values: string[]) => void;
}

export function ButtonToggle({ fields, values, onChange }: Props) {
  return (
    <div tw="flex flex-wrap gap-2">
      {fields.map(field => (
        <ButtonDisplay
          key={field.value}
          onClick={() =>
            onChange(
              values.includes(field.value)
                ? values.filter(v => v !== field.value)
                : [...values, field.value],
            )
          }
          active={values.includes(field.value)}
        >
          {field.label}
        </ButtonDisplay>
      ))}
    </div>
  );
}
